import axios from 'axios';

export const api = axios.create({
  baseURL: '/api/v1',
  timeout: 10000, // 10 second timeout
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request deduplication cache
const pendingRequests = new Map<string, Promise<unknown>>();

// Add request interceptor for deduplication
api.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Add response interceptor for better error handling
api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.code === 'ECONNABORTED') {
      console.error('Request timeout:', error.config.url);
    }
    return Promise.reject(error);
  }
);

// Fetcher with deduplication for SWR
export const fetcher = (url: string) => {
  // Check if there's already a pending request for this URL
  if (pendingRequests.has(url)) {
    return pendingRequests.get(url)!;
  }

  // Create new request and cache the promise
  const request = api
    .get(url)
    .then(res => {
      pendingRequests.delete(url);
      return res.data;
    })
    .catch(error => {
      pendingRequests.delete(url);
      throw error;
    });

  pendingRequests.set(url, request);
  return request;
};
